import { useEffect, useState } from 'react';

export const useScrollbarWidth = () => {
	const [scrollbarWidth, setScrollbarWidth] = useState(0);

	useEffect(() => {
		if (typeof document === 'undefined') {
			return;
		}
		// Crea un div invisible
		const scrollDiv = document.createElement('div');
		scrollDiv.style.visibility = 'hidden';
		scrollDiv.style.overflow = 'scroll';
		document.body.appendChild(scrollDiv);

		// Crea un div dentro del div anterior
		const innerDiv = document.createElement('div');
		scrollDiv.appendChild(innerDiv);

		// Calcula el ancho de la scrollbar
		const scrollbarWidth = scrollDiv.offsetWidth - innerDiv.offsetWidth;

		// Actualiza el estado con el ancho de la scrollbar
		setScrollbarWidth(scrollbarWidth);

		// Limpia el DOM removiendo los divs creados
		document.body.removeChild(scrollDiv);
	}, []);

	return scrollbarWidth;
};
